// utils/modules/spaces — whitespace cleanup helpers.
/**
 * حذف تمام فاصله‌ها (شامل نیم‌فاصله و فاصله‌های یونیکد) از متن
 */
const removeSpaces = (text: string): string => {
  if (!text || text === "") return "";
  let normalized = text;
  normalized = normalized.replace(/\s+/g, "");
  normalized = normalized.replace(/[\u2000-\u200f]/g, "");
  return normalized;
};

export { removeSpaces };
